import React from 'react';
export const App = React.lazy(() => import('./App'));
